import React from 'react';

interface FutureVisionQuestionsProps {
  responses: Record<string, any>;
  onChange: (responses: Record<string, any>) => void;
}

export function FutureVisionQuestions({ responses, onChange }: FutureVisionQuestionsProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">Your Future Vision</h2>
      
      <div className="space-y-4">
        <div>
          <label htmlFor="career_goals" className="block text-sm font-medium text-gray-700">
            What are your long-term career goals?
          </label>
          <textarea
            id="career_goals"
            value={responses.career_goals || ''}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange({ career_goals: e.target.value })}
            rows={3}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
            placeholder="Describe your career vision..."
          />
        </div>

        <div>
          <label htmlFor="work_environment" className="block text-sm font-medium text-gray-700">
            Preferred work environment
          </label>
          <select
            id="work_environment"
            value={responses.work_environment || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange({ work_environment: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select preference</option>
            <option value="remote">Fully Remote</option>
            <option value="hybrid">Hybrid</option>
            <option value="office">Office-based</option>
            <option value="flexible">Flexible</option>
          </select>
        </div>

        <div>
          <label htmlFor="company_type" className="block text-sm font-medium text-gray-700">
            Preferred company type
          </label>
          <select
            id="company_type"
            value={responses.company_type || ''}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange({ company_type: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
          >
            <option value="">Select preference</option>
            <option value="startup">Startup</option>
            <option value="scaleup">Scale-up</option>
            <option value="enterprise">Enterprise</option>
            <option value="consulting">Consulting</option>
            <option value="agency">Agency</option>
          </select>
        </div>
      </div>
    </div>
  );
}